import DataSource from "../data/DataSource";
import { DataTables } from "./DataTables";
import EzUtils from "./EzUtils";
import PrefManager from "../data/model/PrefManager";
import { TaskTypeToRoleMapping } from "./TaskTypeToRoleMapping";
import LoanScopeDataHolder from "../data/model/LoanScopeDataHolder";
import { RolesConstants } from "./RolesConstants";

export default {
  getConsentDetails(officeId, role, officeExternalId) {
    return new Promise(resolve => {
      if (!role) {
        role = this.gerRole();
      }
      DataSource.getConsentDetails(officeId, role, officeExternalId)
        .then(res => {
          resolve(res);
        });
    });
  },

  getLoanStageConfigData(loanId, loanTaskName, role) {
    return new Promise(resolve => {
      if (!role) {
        role = this.gerRole();
      }
      DataSource.getLoanStageConfigData(loanId, loanTaskName, role)
        .then(res => {
          resolve(res);
        });
    });
  },

  updateLoanTask(loanTask, status) {
    loanTask.status = status;
    return new Promise(resolve => {
      DataSource.updateLoanStage(loanTask.loan_id, loanTask.id, loanTask.name, status)
        .then(res => {
          resolve(res)
        })
    })
  },

  updateOtherTask(otherTaskEnum, loanId, taskId, status) {
    //TODO complete for other task
    let payload = {};
    payload.task_status = "VERIFIED";
  },

  /***
   * Complete the current task if present and return next task to execute(null if not present)
   * @param currentLoanTask Task to be done
   * @param loanId
   * @returns {Promise<any>} {"errorOccurred":"true/false", "data":"task(nullable) or error if error occurred"}
   */
  getNextTask(currentLoanTask, loanId) {
    return new Promise(resolve => {
      if (currentLoanTask) {
        if (currentLoanTask.otherTaskEnum) {
          //TODO complete it
          this.updateOtherTask(currentLoanTask.otherTaskEnum, currentLoanTask.loan_id,
            currentLoanTask.id)
            .then(res => {
              //TODO handle it
            });
        } else {
          this.updateLoanTask(currentLoanTask, "COMPLETED")
            .then(res => {
              if (res.errorOccurred) {
                resolve(res)
              } else {
                this.getTasks(loanId, true, currentLoanTask)
                  .then(tasksRes => {
                    if (tasksRes.errorOccurred || (tasksRes.data && EzUtils.isEmpty(tasksRes.data.agentTasks))) {
                      resolve(DataSource.onResponse(null))
                    } else {
                      resolve(DataSource.onResponse(tasksRes.data.agentTasks[0]));
                    }
                  })
              }
            })
        }
      } else {
        this.getTasks(loanId, true, null)
          .then(tasksRes => {
            if (tasksRes.errorOccurred || (tasksRes.data && EzUtils.isEmpty(tasksRes.data.agentTasks))) {
              resolve(DataSource.onResponse(null))
            } else {
              resolve(DataSource.onResponse(tasksRes.data.agentTasks[0]));
            }
          })
      }
    })
  },

  /***
   *
   * @param loanId
   * @param nextTaskRequired
   * @param previousTask
   * @returns {Promise<any>} list of tasks {"errorOccurred":"true/false", "data":"[] or error if error occurred"}
   */
  getTasks(loanId, nextTaskRequired, previousTask) {
    return new Promise(resolve => {
      DataSource.getDataTableInfo(DataTables.TASK_DETAILS, loanId)
      .then(res => {
        if (res.errorOccurred) {
          resolve(res);
        } else {
          const allTasks = res.data;
          const agentTasks =
              this.processLoanTasks(allTasks, nextTaskRequired, previousTask);
          const pendingManualTasks = this.getAllPendingManualTasks(allTasks);
          const responseObject = {agentTasks,pendingManualTasks};

          if (EzUtils.isNotEmpty(agentTasks)) {
            this.fetchLenderCoBrandingDataIfRequiredAndSet(
                agentTasks[agentTasks.length - 1]["lender"],
                agentTasks[agentTasks.length - 1]["surrogate"],
                allTasks
            )
            .then(() => {
              resolve(DataSource.onResponse(responseObject));
            })
          } else {
            resolve(DataSource.onResponse(responseObject));
          }
        }
      })
    });
  },

  doesNeedToWait(loanId) {
    return new Promise(resolve => {
      DataSource.getDataTableInfo(DataTables.TASK_DETAILS, loanId)
        .then(res => {
          if (res.errorOccurred) {
            resolve(DataSource.onResponse({ needToWait: true }));
          } else {
            const needToWait = this.isAnyManualTaskPending(res.data, ["LOAN_ACTIVATION"])
              || this.isAnySystemTaskPending(res.data, ["DISBURSAL"])
            resolve(DataSource.onResponse({ needToWait: needToWait }));
          }
        })
    });
  },

  getAllPendingManualTasks(tasks) {
    let filteredTasks = [];
    tasks.forEach(task => {
      if (this.isManualTask(task.task_type)
        && this.isTaskPending(task.task_status)
      ) {
        filteredTasks.push(task);
      }
    });
    return filteredTasks;
  },

  processLoanTasks(jsonArray, nextTaskRequired, previousTask) {
    let loanTasks = this.filterForStages(jsonArray);
    let nextTask = [];
    for (let index in loanTasks) {
      let loanTask = loanTasks[index];
      // personal task is to be marked completed always
      if (loanTask.name === "PERSONAL" &&
        (loanTask.task_status === "PENDING" || loanTask.task_status === "WAIT")
      ) {
        this.updateLoanTask(loanTask, "COMPLETED");
        //TODO check if this updateLoanTask wait for completion @anish
        continue;
      }

      if (nextTaskRequired &&
        (loanTask.task_status === "PENDING" || loanTask.task_status === "WAIT")
      ) {
        // if we got the task that we just completed as pending, ignore it.
        if (previousTask && previousTask.name === loanTask.name) {
          continue;
        }

        nextTask.push(loanTask);
        break;
      }
    }

    if (nextTaskRequired) {
      return nextTask;
    } else {
      return loanTasks;
    }
  },

  //TODO uncomment this method after task type refactoring
  /*  filterForStages(jsonArray) {
      let filteredTasks = [];
      for (let index in jsonArray) {
        const taskType = jsonArray[index].task_type;
        if (this.isAgentTask(taskType)
          || PrefManager.doesUserHasRole(TaskTypeToRoleMapping[taskType])
        ) {
          filteredTasks.push(jsonArray[index]);
        }
      }
      return filteredTasks;
    },*/

//TODO delete this method after task type refactoring
  filterForStages(jsonArray) {
    let filteredTasks = [];
    for (let index in jsonArray) {
      const taskType = jsonArray[index].task_type;
      const taskName = jsonArray[index].name;
      const taskStatus = jsonArray[index].task_status;
      const taskCompletionType = jsonArray[index].task_completion_type;
      if (this.isAgentTask(taskType)
        || PrefManager.doesUserHasRole(TaskTypeToRoleMapping[taskType])
      ) {
        if (taskStatus === "COMPLETED" && taskCompletionType !== "REPEATABLE") {
          filteredTasks.push(jsonArray[index]);
        } else {
          const allowedTasks = LoanScopeDataHolder.getAllowedTasks();
          if (allowedTasks) {
            if (allowedTasks.includes(taskName)) {
              filteredTasks.push(jsonArray[index]);
            }
          } else {
            filteredTasks.push(jsonArray[index]);
          }
        }
      }
    }
    return filteredTasks;
  },

  isServerTask(taskType) {
    return taskType && taskType === TaskTypeEnum.SYSTEM;
  },

  isAgentTask(taskType) {
    return taskType && taskType === TaskTypeEnum.AGENT;
  },

  isManualTask(taskType) {
    return taskType && taskType === TaskTypeEnum.MANUAL;
  },

  isTaskPending(taskStatus) {
    return "PENDING" === taskStatus
  },

  isAnyManualTaskPending(tasks, ignoredTasks) {
    if (!tasks || tasks.length === 0) {
      return false
    }
    let anyManualTaskPending = false
    tasks.forEach(task => {
      if (this.isManualTask(task.task_type)
        && this.isTaskPending(task.task_status)
        && (!ignoredTasks || !ignoredTasks.includes(task.name))
      ) {
        anyManualTaskPending = true
      }
    })

    return anyManualTaskPending
  },

  isAnySystemTaskPending(tasks, ignoredTasks) {
    if (!tasks || tasks.length === 0) {
      return false
    }
    let anySystemTaskPending = false
    tasks.forEach(task => {
      if (this.isServerTask(task.task_type)
        && this.isTaskPending(task.task_status)
        && (!ignoredTasks || !ignoredTasks.includes(task.name))
      ) {
        anySystemTaskPending = true
      }
    })

    return anySystemTaskPending
  },

  gerRole() {
    let role = "";
    if (PrefManager.doesUserHasRole(RolesConstants.ASM)) {
      role = RolesConstants.ASM;
    } else if (PrefManager.doesUserHasRole(RolesConstants.RETAILER)) {
      role = RolesConstants.RETAILER;
    } else if (PrefManager.doesUserHasRole(RolesConstants.AGENT)) {
      role = RolesConstants.AGENT;
    } else if (PrefManager.doesUserHasRole(RolesConstants.CONSUMER)) {
      role = RolesConstants.CONSUMER;
    }
    return role;
  },

  fetchLenderCoBrandingDataIfRequiredAndSet(lenderName, surrogate, allTasks) {
    return new Promise(resolve => {
      if (lenderName
          && lenderName !== LoanScopeDataHolder.getCoBrandingLenderName()
      ) {
        DataSource.getLenderCoBrandingConfig(lenderName)
        .then(lenderCoBrandingRes => {
          if (lenderCoBrandingRes.errorOccurred) {
            resolve(lenderCoBrandingRes);
          } else {
            const lenderCoBrandingConfig = lenderCoBrandingRes.data
                ? lenderCoBrandingRes.data : {};
            lenderCoBrandingConfig.lenderName = lenderName;
            LoanScopeDataHolder.setLenderCoBrandingData(lenderCoBrandingConfig);
            this.checkSurrogateToCobrandingPresentStages(surrogate, allTasks);
            resolve(DataSource.onResponse(lenderCoBrandingConfig));
          }
        })
      } else {
        this.checkSurrogateToCobrandingPresentStages(surrogate, allTasks);
        resolve(DataSource.onResponse(null));
      }
    });
  },

  checkSurrogateToCobrandingPresentStages(surrogate, allTasks) {
    let showLenderCobranding = false;
    if (surrogate
        && EzUtils.isNotEmpty(allTasks)
        && Object.keys(LoanScopeDataHolder.getLenderCoBrandingData()).length
        !== 0
    ) {
      const existingLenderSurrogate =
          LoanScopeDataHolder.getSurrogateToCobrandingPresentStages();
      if (existingLenderSurrogate && existingLenderSurrogate[surrogate]) {
        const taskToCheck = existingLenderSurrogate[surrogate];
        allTasks.forEach(task => {
          if (task.name === taskToCheck
              && task.lender === LoanScopeDataHolder.getCoBrandingLenderName()
          ) {
            showLenderCobranding = true;
          }
        });
      }
    }
    const lenderCoBrandingConfig = LoanScopeDataHolder.getLenderCoBrandingData();
    LoanScopeDataHolder.clearLenderCoBrandingData();
    lenderCoBrandingConfig.showLenderCobranding = showLenderCobranding;
    LoanScopeDataHolder.setLenderCoBrandingData(lenderCoBrandingConfig);
  }
};

export const TaskTypeEnum = {
  AUTOMATIC: "AUTOMATIC", /*Automatic or system task*/
  SYSTEM: "SYSTEM",
  MANUAL: "MANUAL", /* Manual or ops task */
  FOS: "FOS", /* Task done in field by Feet On Street */
  ASM: "ASM", /* Area Sales Manager Task */
  Operations: "Operations", /* Partner ops */
  Consumer: "Consumer", /* Consumer tasks */
  AGENT: "AGENT"
};
